import {Modal} from 'components';
import React from 'react';

function CardDetailsModal({show, onClose, cardData}) {
  return (
    <Modal
      show={show}
      onClose={onClose}
      extraModalClasses="max-w-[579px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Card Details"
    >
      <div className="py-4 space-y-6">
        <div>
          <h2 className="text-base font-medium text-[#727272] mb-2 text-start">
            Card Holder Details
          </h2>
          <div className="bg-[#F7F7F7] rounded-xl p-6">
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                First Name
              </div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.billingDetails?.firstName}
              </div>
            </div>
            <div className="h-px my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">Last Name</div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.billingDetails?.lastName}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                Address Line 1
              </div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.billingDetails?.addressLine1}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                Address Line 2
              </div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.billingDetails?.addressLine2 || '-'}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">City</div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.billingDetails?.city}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">State</div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.billingDetails?.state}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">Zip Code</div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.billingDetails?.zipCode}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">Country</div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.billingDetails?.country}
              </div>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-base font-medium text-[#727272] mb-2 text-start">
            Card Details
          </h2>
          <div className="bg-[#F7F7F7] rounded-xl p-6">
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">Card Type</div>
              <div
                className={`font-medium text-white text-end uppercase w-fit rounded-full px-2 py-1 h-5   flex items-center justify-center text-xs ${
                  cardData?.cardType?.toLowerCase() === 'visa'
                    ? 'bg-[#2A5392]'
                    : 'bg-[#4A878D]'
                }`}
              >
                {cardData?.cardType}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                Card Number
              </div>
              <div className="text-sm font-medium text-black text-end">
                **** **** **** {cardData?.lastFour}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                Account Limit
              </div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.amountLimit}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                Expiration Date
              </div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.expirationDate}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                Expiration
              </div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.expiration}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                Termination Date
              </div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.terminateDate}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">
                Currency Code
              </div>
              <div className="text-sm font-medium text-black text-end">
                {cardData?.currencyCode}
              </div>
            </div>
            <div className="h-[0.5px] my-4 bg-[#E1E4EA] w-full" />
            <div className="flex items-center justify-between">
              <div className="text-sm text-[#868C98] text-start">Status</div>
              <div
                className={`font-medium text-end uppercase w-fit rounded-full px-2 py-1 h-5   flex items-center justify-center text-xs ${
                  cardData?.status === 'Card - Active'
                    ? 'bg-[#F0F6EF] text-[#55A249]'
                    : cardData?.status === 'Card - Frozen'
                    ? 'bg-[#F8EBEA] text-[#B42318]'
                    : 'bg-[#ECECEC] text-[#1D1D1D]'
                }`}
              >
                {cardData?.status === 'Card - Active'
                  ? 'Active'
                  : cardData?.status === 'Card - Frozen'
                  ? 'Frozen'
                  : 'Terminated'}{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default CardDetailsModal;
